import { render, staticRenderFns } from "./ViewInceptMsgAdress.vue?vue&type=template&id=6bd2d15e&scoped=true&"
import script from "./ViewInceptMsgAdress.vue?vue&type=script&lang=ts&"
export * from "./ViewInceptMsgAdress.vue?vue&type=script&lang=ts&"
import style0 from "./ViewInceptMsgAdress.vue?vue&type=style&index=0&id=6bd2d15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2d15e",
  null
  
)

export default component.exports